import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    user_theme: ''
  },
  actions: actions,
  mutations: mutations,
  getters: getters
}
